import { render, staticRenderFns } from "./iceMountain.vue?vue&type=template&id=334f5f7a&scoped=true"
import script from "./iceMountain.vue?vue&type=script&lang=ts"
export * from "./iceMountain.vue?vue&type=script&lang=ts"
import style0 from "./iceMountain.vue?vue&type=style&index=0&id=334f5f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334f5f7a",
  null
  
)

export default component.exports